/**
 * Smoothly scrolls the page to the element referenced by a React ref.
 *
 * @param {Object} ref - A React ref object pointing to the DOM element.
 */
export const scrollToRef = (ref) => {
  if (ref?.current) {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

/**
 * Smoothly scrolls the page to an element by its ID, with optional top margin.
 *
 * @param {string} id - The ID of the element to scroll to.
 * @param {number} [margin=50] - The margin from the top of the element after scrolling (default is 50px).
 */
export const scrollToId = (id, margin = 50) => {
  const element = document.getElementById(id);
  if (element) {
    const top = element.getBoundingClientRect().top + window.scrollY - margin;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  }
};
